import React, { useContext } from 'react';

import { FlexDiv, Headings, ResponsiveContainer, GenericDiv } from '../../../../common/Styles';
import { BenefitWrap, BenefitWrapper, BenefitCurveWrapper, BenefitsCurve, Listing, ImageSec } from './benefitsStyles';
import { BorderWrap } from '../../Styles';
import { ASSET_PATH } from '../../../../../assetsPath';

const expenseImgPath = `${ASSET_PATH.IMAGES}seo/expense/`;

import { benefitsData } from '../../config';
import { isMobileContext } from '../../../../UtilityComponents/Util';
import DisplayContext from '../../../../UtilityComponents/displayContext';
import ActionButtons from '../../../../bizLanding/components/actionButtons/actionButtons';
import { LANDING_CONSTS } from '../../../../AppConstants';

const FeatureComp = ({ isLoggedInUser = false }) => {
	const { heading: headTxt, features = [] } = benefitsData;
	const displayName = useContext(DisplayContext).isMobile;
	const isMobile = isMobileContext(displayName);
	return (
		<BenefitWrapper id='Benefits'>
			<BenefitCurveWrapper>
				<BenefitsCurve />
			</BenefitCurveWrapper>
			<ResponsiveContainer isNoBTPadd>
				<BorderWrap />
				<Headings color='#fff' as={isMobile ? 'h3' : 'h1'} dangerouslySetInnerHTML={{ __html: headTxt }} />
				<FlexDiv $width='auto' overflow='auto' justify='space-between' top_M='78' fsize='20px' text_align='center'>
					{features.map((feature, i)=> {
						const { heading, icon, list } = feature;
						return (
							<BenefitWrap $bg={icon} key={i}>
								<ImageSec loading='lazy' src={`${expenseImgPath}${icon}.png`} alt={heading} />
								<Headings className='feature-head' color='#fff' as={isMobile ? 'h4' : 'h3'}>{heading}</Headings>
								<Listing>{list.map((item, j)=>(
									<li key={j}>{item}</li>
								))}
								</Listing>

							</BenefitWrap>
						);
					})}
				</FlexDiv>
				<GenericDiv top_M={isMobile ? '38' : '67'}>
					<Headings as={isMobile ? 'h4' : 'h2'} color='#fff'>Get your benefits by creating your own account!</Headings>
					<GenericDiv $width='300px' top_M='24'>
						<ActionButtons show={LANDING_CONSTS.SIGNUP} signupTxt={isLoggedInUser ? 'GET STARTED' : 'SIGN UP NOW'} />
					</GenericDiv>
				</GenericDiv>
			</ResponsiveContainer>
		</BenefitWrapper>
	);
};

export default FeatureComp;
